import { AuthInterceptor } from './auth.interceptor';
import { CookieInterceptor } from './cookie.interceptor';
import { SearchRequestInterceptor } from './search-request.interceptor';

import { ApiInterceptor } from './api.interceptor';
import { AuthKeyInterceptor } from '@hiptraveler/data-access/api';
import { RequestCancellationInterceptor as _RequestCancellationInterceptor } from './request-cancellation.interceptor';
import { DynamicRequestCancellationInterceptor } from './dynamic-request-cancellation.interceptor';
import { SearchRequestCancellationInterceptor } from './search-request-cancellation.interceptor';
import { ProfileSearchRequestCancellationInterceptor } from './profile-search-request-cancellation.interceptor';

const RequestCancellationInterceptor = [
  _RequestCancellationInterceptor,
  DynamicRequestCancellationInterceptor,
  SearchRequestCancellationInterceptor,
  ProfileSearchRequestCancellationInterceptor,
];

export const AppInterceptors = [
  ApiInterceptor,
  AuthInterceptor,
  CookieInterceptor,
  SearchRequestInterceptor,
  RequestCancellationInterceptor
];
